/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Icon } from '@az/starc-ui';
import { ChevronRight } from '@az/starc-ui-icons';
import { useLabels } from '@/hooks/useLabels';
import styles from './Carousel.module.scss';

type CarouselArrowsProps = {
  canScrollPrevious: boolean;
  canScrollNext: boolean;
  showOnDesktop: boolean;
  onPrevious: () => void;
  onNext: () => void;
};

const labelMap = {
  previous: 'label_reviews_customerImagesModal_prev',
  next: 'label_reviews_customerImagesModal_next',
};

const CarouselArrows = ({
  canScrollPrevious,
  canScrollNext,
  showOnDesktop,
  onPrevious,
  onNext,
}: CarouselArrowsProps) => {
  const labels = useLabels(labelMap);

  return (
    <div className={styles.Arrows}>
      <button
        type="button"
        className={`${styles.Arrow} ${styles.Previous} ${
          canScrollPrevious && showOnDesktop ? styles.DesktopVisible : ''
        }`}
        aria-label={labels.previous}
        disabled={!canScrollPrevious}
        onClick={onPrevious}
      >
        <span className={styles.FlippedIcon}>
          <Icon svg={ChevronRight} attributes={{ style: { width: 24, height: 24 } }} />
        </span>
      </button>
      <button
        type="button"
        className={`${styles.Arrow} ${styles.Next} ${
          canScrollNext && showOnDesktop ? styles.DesktopVisible : ''
        }`}
        aria-label={labels.next}
        disabled={!canScrollNext}
        onClick={onNext}
      >
        <Icon svg={ChevronRight} attributes={{ style: { width: 24, height: 24 } }} />
      </button>
    </div>
  );
};

export default CarouselArrows;
